import React, { useState, useEffect } from 'react';
import api from '../../../../services/api';
import { toast } from 'react-hot-toast';

export default function DeleteConfirmationModal({
  open,
  onClose,
  onConfirmSuccess,
  itemType,
  item,
}) {
  const [dependencies, setDependencies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    if (open && item) {
      const fetchDependencies = async () => {
        setLoading(true);
        try {
          // Lógica para pluralizar corretamente o endpoint da API
          const endpoint = itemType === 'company' ? 'companies' : 'users';
          const identifier = itemType === 'company' ? item.slug : item.userName;
          const res = await api.get(`/${endpoint}/${identifier}/dependencies`);
          const foundDependencies = [];

          if (res.data.users?.length > 0) {
            foundDependencies.push({
              label: 'Usuários Associados',
              items: res.data.users.map(u => u.fullName), // Corrigido de 'name' para 'fullName'
            });
          }

          if (res.data.isLastAdminOf) {
            foundDependencies.push({
              label: 'É o único administrador das seguintes empresas',
              items: res.data.isLastAdminOf.map(c => c.name), // Corrigido de tradeName para name
            });
          }

          setDependencies(foundDependencies);
        } catch (error) {
          console.error('Erro ao buscar dependências:', error);
          // Tratar erro, talvez fechar o modal e mostrar um alerta
        } finally {
          setLoading(false);
        }
      };

      fetchDependencies();
    }
  }, [open, item, itemType]);

  const handleConfirm = async () => {
    if (!item) return;
    setIsDeleting(true);
    try {
      const endpoint = itemType === 'company' ? 'companies' : 'users';
      const identifier = itemType === 'company' ? item.slug : item.userName;

      await api.delete(`/${endpoint}/${identifier}`);

      toast.success(
        `${itemType === 'company' ? 'Empresa' : 'Usuário'} movido para a lixeira com sucesso!`
      );
      onConfirmSuccess(item); // Notifica o componente pai sobre o sucesso
      onClose(); // Fecha o modal
    } catch (error) {
      if (error.response && error.response.status === 400) {
        // Erro específico do backend (ex: tentar se auto-excluir)
        toast.error(error.response.data.msg || 'Não foi possível mover para a lixeira.');
      } else {
        console.error('Erro ao mover para a lixeira:', error);
        toast.error('Ocorreu um erro ao tentar mover para a lixeira.');
      }
    } finally {
      setIsDeleting(false);
    }
  };
  if (!open) return null;

  // Para soft-delete, a presença de dependências é apenas informativa.
  const hasDependencies = dependencies.length > 0;
  const itemName = item?.name || item?.fullName || item?.slug; // Garante que o nome do usuário (fullName) também seja considerado

  const renderContent = () => {
    if (loading) {
      return <div className="loading-state">Verificando dependências...</div>;
    }

    if (hasDependencies) {
      return (
        <>
          <p>
            Tem certeza que deseja mover <strong>{itemName}</strong> para a lixeira?
          </p>
          <p className="modal-tip">
            Os seguintes dados permanecerão vinculados e a empresa ficará inacessível até ser
            restaurada:
          </p>
          <div className="dependencies-list">
            {dependencies.map(dep => (
              <div key={dep.label}>
                <strong>{dep.label}:</strong>
                <ul>
                  {dep.items.map(name => (
                    <li key={name}>{name}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </>
      );
    }

    return (
      <p>
        Tem certeza que deseja mover <strong>{itemName}</strong> para a lixeira?
      </p>
    );
  };

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div
        className="edit-modal card"
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: '500px' }}
      >
        <div className="card-body">
          <div className="modal-header">
            <h3>Excluir {itemType === 'company' ? 'Empresa' : 'Usuário'}</h3>
            <button onClick={onClose} className="btn btn-secondary">
              ✕
            </button>
          </div>

          <div className="modal-content">{renderContent()}</div>

          <div className="modal-actions">
            <button type="button" onClick={onClose} className="btn btn-secondary">
              Cancelar
            </button>
            {!loading && (
              <button
                type="button"
                onClick={handleConfirm}
                className="btn btn-danger"
                disabled={isDeleting}
              >
                {isDeleting ? 'Movendo...' : 'Mover para Lixeira'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
